import axios from 'axios';

// import authHeader from "@/service/auth-header";

class AuthenticationService {

    async authenticateUser(data) {
        console.log("[AuthenticationService][authenticateUser] Before. Data = ", data);

        return await axios.post(`/api/auth/signin`, data);
    }

    async signoutUser(username) {
        console.log("[AuthenticationService][signoutUser] username = ", username);

        return await axios.post(`/api/auth/signout/${username}`, null);
    }

    async twoFactorAuthentication(username) {
        console.log("[AuthenticationService][authenticateUser] Before. username = ", username);

        return await axios.post(`/api/auth/twofactor/${username}`);
    }

    async authenticateUserWithPasswordReset(data) {
        console.log("[AuthenticationService][authenticateUserWithPasswordReset] Before. Data = ", data);

        return await axios.post(`/api/auth/signinpasswordreset`, data);
    }


    async registerUser(data) {
        console.log("[AuthenticationService][registerUser] Before. Data = ", data);

        return await axios.post(`/api/auth/signup`, data);
    }

    async resetPassword(email) {
        console.log("[AuthenticationService][resetPassword] Before. Email = ", email);

        return await axios.post(`/api/auth/resetpassword/${email}`);
    }

}

export default new AuthenticationService();
